import React from "react";
import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";
import Typography from "@mui/material/Typography";
import { ITEM_SIZE } from "./VirtualizedListbox";

const VIRTUAL_PALLET_LOCATION = "Virtual Pallet Location";
const ASSIGN_VIRTUAL_PALLET = "Assign Virtual Pallet";

const styles = {
  item: {
    height: ITEM_SIZE,
  },
};

export default function LocationOption({ props, option, onSelectLocationPosition }) {
  if (option === "loading") {
    return (
      <Box component="li" {...props} sx={styles.item}>
        <Skeleton width="30%" />
      </Box>
    );
  }

  if (!option.visible) {
    return null;
  }

  const handleSelect = () => {
    onSelectLocationPosition(option.locations);
  };

  const showWarehouse = option.warehouseName && (
    <Typography ml={0.5}  color="text.secondary" fontSize={14}>
      {" — "}
      {option.warehouseName}
    </Typography>
  );
  const locationName =
    option.locationName === VIRTUAL_PALLET_LOCATION ? ASSIGN_VIRTUAL_PALLET : option.name;

  if (option.locations?.length > 1) {
    return (
      <Box
        component="li"
        {...props}
        sx={styles.item}
        onTouchStart={undefined}
        onClick={handleSelect}
      >
        {locationName}
        {showWarehouse}
      </Box>
    );
  }

  return (
    <Box component="li" {...props} sx={styles.item}>
      {locationName}
      {showWarehouse}
    </Box>
  );
}
